import { getApi } from '../apiClient';
import {
  ICourseDetails,
  ICourseGetResponse,
  ICourseDetailsReviewsGetResponse,
  IAssignedCoursesGetResponse,
  ICourseProgressGetResponse
} from './types';

export async function fetchCourse(
  courseSlug: ICourseDetails['slug']
): Promise<ICourseGetResponse> {
  const { data } = await getApi().get<ICourseGetResponse>(`/courses/${courseSlug}`);

  return data;
}

export async function fetchCourseReviews(
  courseSlug: ICourseDetails['slug']
): Promise<ICourseDetailsReviewsGetResponse> {
  const { data } = await getApi().get<ICourseDetailsReviewsGetResponse>(
    `/courses/${courseSlug}/reviews`
  );

  return data;
}

export async function fetchAssignedCourses(): Promise<IAssignedCoursesGetResponse> {
  const { data } = await getApi().get<IAssignedCoursesGetResponse>(`/profile/courses`);

  return data;
}

export async function fetchCourseProgress(
  courseSlug: ICourseDetails['slug']
): Promise<ICourseProgressGetResponse> {
  const { data } = await getApi().get<ICourseProgressGetResponse>(
    `/courses/${courseSlug}/progress`
  );

  return data;
}
